import { Button } from 'components/atoms'
import NavItems from 'components/atoms/NavItems'
import * as React from 'react'
import { BREAKPOINT_TABLET_LARGE, COLORS } from 'static/constants'
import styled from 'styled-components'
import I18n from 'core/i18n'
import { getNavItemsWithActive } from 'utils/layout'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  roleLabel: string
  approvedUser: boolean
}

export const SidebarContent: React.VFC<IProps> = ({ roleLabel, approvedUser }) => {
  const withActive = getNavItemsWithActive(roleLabel)
  const isMobile = matchMedia(`(max-width: ${BREAKPOINT_TABLET_LARGE}px)`).matches
  return (
    <>
      <NavItems navItemArray={withActive} dashboard={true} />
      {roleLabel !== 'guide' && (
        <Buttons>
          {approvedUser && (
            <Button
              textColor={COLORS.white}
              backgroundColor={COLORS.primary}
              fullWidth={true}
              small={isMobile}
            >
              <a href="/agent/posts/new">
                <SvgIcon name="add" className="icon" ariaHidden={true} role="presentation" />
                <span>{I18n.t('top_nav.create_post')}</span>
              </a>
            </Button>
          )}
          {approvedUser && (
            <Button
              primary={false}
              textColor={COLORS.primary}
              borderColor={COLORS.primary}
              fullWidth={true}
              small={isMobile}
            >
              <a href="/agent/direct_reservations/new">
                <SvgIcon name="add" className="icon" ariaHidden={true} role="presentation" />
                <span>{I18n.t('top_nav.create_direct_reservation')}</span>
              </a>
            </Button>
          )}
        </Buttons>
      )}
    </>
  )
}

const Buttons = styled.div`
  padding: 8px 0 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;
  button {
    > a {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
    & + button {
      margin-left: 0 !important;
    }
  }
  @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
    padding: 16px;
  }
`
